// For snippets/video.liquid
function playVideo(element) {
  const parentElement = element.parentElement;
  const video = parentElement.querySelector("video");

  if (!parentElement.classList.contains("mdbio__video_played_once")) {
    parentElement.classList.add("mdbio__video_played_once");
  }

  if (parentElement.classList.contains("mdbio__video_playing")) {
    video.pause();
    parentElement.classList.remove("mdbio__video_playing");
  } else {
    video.play();
    parentElement.classList.add("mdbio__video_playing");
  }
}
